/**
 * All the string prototype modifications should be here
 * 1. Declare the function inside of the String interface
 * 2. Create the function and assign it to the prototype of the String interface
 */
export {};
declare global {
  interface String {
    capitalizeFirstLetter(): string;
  }
}
String.prototype.capitalizeFirstLetter = function () {
  if (this && this.length > 0) {
    return this.charAt(0).toUpperCase() + this.slice(1);
  }
  return this;
};
